import { Icon } from "@iconify/react";

const Alert = ({ variant, icon, iconClassName, title, message, className }) => {
  const getVariantClassName = () => {
    let baseClassName = `p-4 rounded-[14px] border-2 border-primary-blur-02 flex ${
      title ? "flex-col items-start" : "flex-row items-center"
    } gap-2 text-xs `;
    switch (variant) {
      case "success":
        baseClassName += "bg-green-500 text-white";
        break;
      case "error":
        baseClassName += "bg-red-500 text-white";
        break;
      case "warning":
        baseClassName += "bg-yellow-500 text-white";
        break;
      case "info":
        baseClassName += "bg-[#F1F5FF] text-[#253477B2] ";
        break;
      case "gradient":
        baseClassName +=
          "bg-[linear-gradient(180deg,#F1F5FF_0%,#FFF_100%)] text-[#253477B2] ";
        break;

      case "primary-gradient":
        baseClassName += "bg-primary-gradient text-white ";
    }

    baseClassName += className ? ` ${className} ` : "";
    return baseClassName;
  };

  const getIconClassName = () => {
    return `w-4 h-4 ${iconClassName ?? ""} `;
  };

  return (
    <div className={getVariantClassName()}>
      {icon && <Icon icon={icon} className={getIconClassName()} />}

      <div className="">
        {title && <h3 className="font-semibold mb-2 text-base">{title}</h3>}
        {message && <span>{message}</span>}
      </div>
    </div>
  );
};

export default Alert;
